import { FC, ReactNode } from 'react';
import TitleContainer from 'components/Filters/common/TitleContainer';

interface FilterWrapperProps {
  children: ReactNode;
}

const FilterWrapper: FC<FilterWrapperProps> = ({ children }) => {
  return (
    <div className="filters">
      <TitleContainer />
      {children}
    </div>
  );
};

export default FilterWrapper;
